
export const AppSettings = {


  //base_url: 'http://192.168.0.181:7006/',
  //base_url: 'http://200.1.50.108:7006/',
  //base_url: 'http://13.127.71.165:7000/',
  //base_url: 'http://200.1.50.102:7003/',

//base_url: 'http://200.1.50.113:7006/',
   base_url: 'https://api.poswagon.com/',

  //base_url: 'https://api.expresswala.com/',

  //base_url: 'https://apibistrosuit.renoinfo.in/',

  //Restaurant
  insertRestaurantUrl: 'restaurant/insertrestaurant',
  setRestaurantUrl: 'restaurant/setrestaurant',
  checkRestaurantUrl: 'restaurant/checkrestaurant',
  getRestaurantUrl: 'restaurant/getrestaurant',
  deleteRestaurantUrl: 'restaurant/deleterestaurant',

  //Category
  insertCategoryUrl: 'category/insertcategory',
  setCategoryUrl: 'category/setcategory',
  checkCategoryUrl: 'category/checkcategory',
  getCategoryUrl: 'category/getcategory',
  deleteCategoryUrl: 'category/deletecategory',

  //Subcategory
  insertSubcategoryUrl: 'subcategory/insertsubcategory',
  setSubcategoryUrl: 'subcategory/setsubcategory',
  checkSubcategoryUrl: 'subcategory/checksubcategory',
  getSubcategoryUrl: 'subcategory/getsubcategory',
  deleteSubcategoryUrl: 'subcategory/deletesubcategory',


  //User
  insertUserUrl: 'user/insertuser',
  setUserUrl: 'user/setuser',
  setUserPasswordUrl: 'user/setuserpassword',
  checkUserUrl: 'user/checkuser',
  getUserUrl: 'user/getuser',
  deleteUserUrl: 'user/deleteuser',
  getLoginUserUrl: 'user/getloginuser',
  getLoginSecuritykeyUrl: 'user/getloginsecuritykey',
  getUserBranchUrl: 'user/getuserbranch',


  //Product
  insertProductUrl: 'product/insertproduct',
  setProductUrl: 'product/setproduct',
  checkProductUrl: 'product/checkproduct',
  getProductUrl: 'product/getproduct',
  getProductListviewUrl: 'product/getproductlistview',
  getProductReceipeUrl: 'product/getproductreceipe',
  deleteProductUrl: 'product/deleteproduct',
  getProductPriceUrl: 'product/getproductprice',
  setProductPriceUrl: 'product/setproductprice',
  getProductAutoCodeUrl: 'product/getproductautocode',


  insertProductVariationsUrl: 'product/insertproductvariations',
  setProductVariationsUrl: 'product/setproductvariations',
  deleteProductVariationsUrl: 'product/deleteproductvariations',
  checkProductVariationsUrl: 'product/checkproductvariations',

  insertProductImportUrl: 'product/insertproductimport',

  //Userrole
  insertUserroleUrl: 'userrole/insertuserrole',
  setUserroleUrl: 'userrole/setuserrole',
  checkUserroleUrl: 'userrole/checkuserrole',
  getUserroleUrl: 'userrole/getuserrole',
  deleteUserroleUrl: 'userrole/deleteuserrole',

  getUserRoleRightsUserUrl: 'userrole/getuserrolerightsbyuserid',
  getUserRoleRightsUrl: 'userrole/getuserrolerights',


  //Question
  insertQuestionUrl: 'question/insertquestion',
  setQuestionUrl: 'question/setquestion',
  checkQuestionUrl: 'question/checkquestion',
  getQuestionUrl: 'question/getquestion',
  deleteQuestionUrl: 'question/deletequestion',

  //Answertype
  getAnswertypeUrl: 'answertype/getanswertype',


  //Feedback
  getFeedbackListviewUrl: 'feedback/getfeedbackbylistview',
  getFeedbackUrl: 'feedback/getfeedbackbyfeedbackid',

  //Branch
  insertBranchUrl: 'branch/insertbranch',
  setBranchUrl: 'branch/setbranch',
  checkBranchUrl: 'branch/checkbranch',
  getBranchUrl: 'branch/getbranch',
  deleteBranchUrl: 'branch/deletebranch',

  //Settings
  getReceiptSettingsUrl: 'settings/getreceiptsettings',
  setReceiptSettingsUrl: 'settings/setreceiptsettings',

  //Brand
  insertBrandUrl: 'brand/insertbrand',
  setBrandUrl: 'brand/setbrand',
  checkBrandUrl: 'brand/checkbrand',
  getBrandUrl: 'brand/getbrand',
  deleteBrandUrl: 'brand/deletebrand',

  //Cardtype
  insertCardtypeUrl: 'cardtype/insertcardtype',
  setCardtypeUrl: 'cardtype/setcardtype',
  checkCardtypeUrl: 'cardtype/checkcardtype',
  getCardtypeUrl: 'cardtype/getcardtype',
  deleteCardtypeUrl: 'cardtype/deletecardtype',


  //Company
  insertCompanyUrl: 'company/insertcompany',
  setCompanyUrl: 'company/setcompany',
  checkCompanyUrl: 'company/checkcompany',
  getCompanyUrl: 'company/getcompany',
  deleteCompanyUrl: 'company/deletecompany',


  //Course
  insertCourseUrl: 'course/insertcourse',
  setCourseUrl: 'course/setcourse',
  checkCourseUrl: 'course/checkcourse',
  getCourseUrl: 'course/getcourse',
  deleteCourseUrl: 'course/deletecourse',

  //Cuisine
  insertCuisineUrl: 'cuisine/insertcuisine',
  setCuisineUrl: 'cuisine/setcuisine',
  checkCuisineUrl: 'cuisine/checkcuisine',
  getCuisineUrl: 'cuisine/getcuisine',
  deleteCuisineUrl: 'cuisine/deletecuisine',

  //Department
  insertDepartmentUrl: 'department/insertdepartment',
  setDepartmentUrl: 'department/setdepartment',
  checkDepartmentUrl: 'department/checkdepartment',
  getDepartmentUrl: 'department/getdepartment',
  deleteDepartmentUrl: 'department/deletedepartment',

  //Dinetype
  insertDinetypeUrl: 'dinetype/insertdinetype',
  setDinetypeUrl: 'dinetype/setdinetype',
  checkDinetypeUrl: 'dinetype/checkdinetype',
  getDinetypeUrl: 'dinetype/getdinetype',
  deleteDinetypeUrl: 'dinetype/deletedinetype',

  //Group
  insertGroupUrl: 'group/insertgroup',
  setGroupUrl: 'group/setgroup',
  checkGroupUrl: 'group/checkgroup',
  getGroupUrl: 'group/getgroup',
  deleteGroupUrl: 'group/deletegroup',

  //Subgroup
  insertSubgroupUrl: 'subgroup/insertsubgroup',
  setSubgroupUrl: 'subgroup/setsubgroup',
  checkSubgroupUrl: 'subgroup/checksubgroup',
  getSubgroupUrl: 'subgroup/getsubgroup',
  deleteSubgroupUrl: 'subgroup/deletesubgroup',

  //Modifier
  insertModifierUrl: 'modifier/insertmodifier',
  setModifierUrl: 'modifier/setmodifier',
  checkModifierUrl: 'modifier/checkmodifier',
  getModifierUrl: 'modifier/getmodifier',
  deleteModifierUrl: 'modifier/deletemodifier',

  //Modifiertype
  insertModifiertypeUrl: 'modifiertype/insertmodifiertype',
  setModifiertypeUrl: 'modifiertype/setmodifiertype',
  checkModifiertypeUrl: 'modifiertype/checkmodifiertype',
  getModifiertypeUrl: 'modifiertype/getmodifiertype',
  deleteModifiertypeUrl: 'modifiertype/deletemodifiertype',

  //Ordermode
  insertOrdermodeUrl: 'ordermode/insertordermode',
  setOrdermodeUrl: 'ordermode/setordermode',
  checkOrdermodeUrl: 'ordermode/checkordermode',
  getOrdermodeUrl: 'ordermode/getordermode',
  deleteOrdermodeUrl: 'ordermode/deleteordermode',

  //Party
  insertPartyUrl: 'party/insertparty',
  setPartyUrl: 'party/setparty',
  checkPartyUrl: 'party/checkparty',
  getPartyUrl: 'party/getparty',
  getPartyFindUrl: 'party/getpartyfind',

  deletePartyUrl: 'party/deleteparty',

  //Paymentmode
  insertPaymentmodeUrl: 'paymentmode/insertpaymentmode',
  setPaymentmodeUrl: 'paymentmode/setpaymentmode',
  checkPaymentmodeUrl: 'paymentmode/checkpaymentmode',
  getPaymentmodeUrl: 'paymentmode/getpaymentmode',
  getPaymentmodeTransactionUrl: 'paymentmode/getpaymentmodetransaction',
  deletePaymentmodeUrl: 'paymentmode/deletepaymentmode',


  //Reason
  insertReasonUrl: 'reason/insertreason',
  setReasonUrl: 'reason/setreason',
  checkReasonUrl: 'reason/checkreason',
  getReasonUrl: 'reason/getreason',
  deleteReasonUrl: 'reason/deletereason',

  //Shift
  insertShiftUrl: 'shift/insertshift',
  setShiftUrl: 'shift/setshift',
  checkShiftUrl: 'shift/checkshift',
  getShiftUrl: 'shift/getshift',
  deleteShiftUrl: 'shift/deleteshift',

  //Size
  insertSizeUrl: 'size/insertsize',
  setSizeUrl: 'size/setsize',
  checkSizeUrl: 'size/checksize',
  getSizeUrl: 'size/getsize',
  deleteSizeUrl: 'size/deletesize',

  //Tax
  insertTaxUrl: 'tax/inserttax',
  setTaxUrl: 'tax/settax',
  checkTaxUrl: 'tax/checktax',
  getTaxUrl: 'tax/gettax',
  deleteTaxUrl: 'tax/deletetax',


  //Uom
  insertUomUrl: 'uom/insertuom',
  setUomUrl: 'uom/setuom',
  checkUomUrl: 'uom/checkuom',
  getUomUrl: 'uom/getuom',
  deleteUomUrl: 'uom/deleteuom',

  //Station
  insertStationUrl: 'station/insertstation',
  setStationUrl: 'station/setstation',
  checkStationUrl: 'station/checkstation',
  getStationUrl: 'station/getstation',
  deleteStationUrl: 'station/deletestation',

  //TableSection
  insertTableSectionUrl: 'tablesection/inserttablesection',
  setTableSectionUrl: 'tablesection/settablesection',
  checkTableSectionUrl: 'tablesection/checktablesection',
  getTableSectionUrl: 'tablesection/gettablesection',
  deleteTableSectionUrl: 'tablesection/deletetablesection',
  getTableByTableSectionUrl: 'tablesection/gettablebytablesection',

  //Table
  insertTableUrl: 'table/inserttable',
  setTableUrl: 'table/settable',
  checkTableUrl: 'table/checktable',
  getTableUrl: 'table/gettable',
  deleteTableUrl: 'table/deletetable',

  //Foodsymbol
  insertFoodsymbolUrl: 'foodsymbol/insertfoodsymbol',
  setFoodsymbolUrl: 'foodsymbol/setfoodsymbol',
  checkFoodsymbolUrl: 'foodsymbol/checkfoodsymbol',
  getFoodsymbolUrl: 'foodsymbol/getfoodsymbol',
  deleteFoodsymbolUrl: 'foodsymbol/deletefoodsymbol',

  //Locality
  insertLocalityUrl: 'locality/insertlocality',
  setLocalityUrl: 'locality/setlocality',
  checkLocalityUrl: 'locality/checklocality',
  getLocalityUrl: 'locality/getlocality',
  deleteLocalityUrl: 'locality/deletelocality',


  //Settings
  setSettingsCompanyUrl: 'settings/setsettingscompany',
  getSettingsCompanyUrl: 'settings/getsettingscompany',

  //Shiftactivity
  insertShiftactivityUrl: 'shiftactivity/insertshiftactivity',
  checkShiftactivityUrl: 'shiftactivity/checkshiftactivity',


  //Currency
  insertCurrencyUrl: 'currency/insertcurrency',
  setCurrencyUrl: 'currency/setcurrency',
  checkCurrencyUrl: 'currency/checkcurrency',
  getCurrencyListviewUrl: 'currency/getcurrencylistview',
  getCurrencyUrl: 'currency/getcurrency',
  deleteCurrencyUrl: 'currency/deletecurrency',




  //Sales
  getDashDinetypeUrl: 'dashboard/getdashdinetype',
  getDashTablesectionUrl: 'dashboard/getdashtablesection',
  getDashTableUrl: 'dashboard/getdashtable',
  getDashGroupUrl: 'dashboard/getdashgroup',
  getDashProductListviewUrl: 'dashboard/getdashproductlist',
  getDashProductDetailsUrl: 'dashboard/getdashproductdetails',
  getDashPaymentmodeUrl: 'dashboard/getdashpaymentmode',
  getDashCashDenaminaionUrl: 'dashboard/getdashcashdenamination',
  getChargesBySalesUrl: 'dashboard/getchargesbysales',
  getSalesListClosedOpenUrl: 'dashboard/getsaleslistclosedopened',


  insertSalesUrl: 'dashboard/insertsales',
  getSalesBySalesDetailsUrl: 'dashboard/getsalesdetailsbysalesid',
  getSalesByPrintUrl: 'dashboard/getsalesbyprint',
  getPrintKotBySalesUrl: 'dashboard/getprintkotbysalesid',

  //Income
  insertIncomeUrl: 'income/insertincome',
  setIncomeUrl: 'income/setincome',
  checkIncomeUrl: 'income/checkincome',
  getIncomeUrl: 'income/getincomebyincomeid',
  getIncomeListviewUrl: 'income/getincomelistview',
  deleteIncomeUrl: 'income/deleteincome',


  //Charges
  insertChargesUrl: 'charges/insertcharges',
  setChargesUrl: 'charges/setcharges',
  checkChargesUrl: 'charges/checkcharges',
  getChargesUrl: 'charges/getcharges',
  deleteChargesUrl: 'charges/deletecharges',


  //Expense
  insertExpenseUrl: 'expense/insertexpense',
  setExpenseUrl: 'expense/setexpense',
  checkExpenseUrl: 'expense/checkexpense',
  getExpenseUrl: 'expense/getexpensebyexpenseid',
  getExpenseListviewUrl: 'expense/getexpenselistview',
  deleteExpenseUrl: 'expense/deleteexpense',

  //Voucher
  insertVoucherUrl: 'voucher/insertvoucher',
  setVoucherUrl: 'voucher/setvoucher',
  checkVoucherUrl: 'voucher/checkvoucher',
  getVoucherUrl: 'voucher/getvoucher',
  deleteVoucherUrl: 'voucher/deletevoucher',

  //Activitylog
  insertActivitylogUrl: 'common/insertactivitylog',

  //Report
  getopenbillreportUrl: 'report/getopenbillreport',
  getActivitylogReportUrl: 'report/getactivitylogreport',
  getUserappformUrl: 'report/getuserappform',
  getSalesReportUrl: 'report/getsalesreport',
  getStockReportUrl: 'report/getstockreport',
  getStockRangeReportUrl: 'report/getstockrangereport',
  getPurchaseReportUrl: 'report/getpurchasereport',
  getAdjReportUrl: 'report/getadjreport',
  getProductCancelReportUrl: 'report/getproductcancelreport',
  getBillCancelReportUrl: 'report/getbillcancelreport',
  getBillSummaryReportUrl: 'report/getbillsummaryreport',
  getTaxSummaryReportUrl: 'report/gettaxsummaryreport',
  getSalesxReportUrl: 'report/getsalesxreport',
  getIncomeReportUrl: 'report/getincomereport',
  getExpenseReportUrl: 'report/getexpensereport',
  getExpenseDetailsReportUrl: 'report/getexpensedetailsreport',
  getHourlyitemsalesReportUrl: 'report/gethourlyitemsales',
  getPaymentwiseOrderReportUrl: 'report/getpaymentwiseorderreport',
  getStationwiseReportUrl: 'report/getstationwisereport',
  getSalesGroupReportUrl: 'report/getsalesgroupreport',
  getSalesProductReportUrl: 'report/getsalesproductreport',
  getSalesDineTypeReportUrl: 'report/getsalesdinetypereport',
  getSalesDailyReportUrl: 'report/getsalesdailyreport',
  getSalesDailyShiftReportUrl: 'report/getsalesdailyshiftreport',
  getSalesDailyPaymentReportUrl: 'report/getsalesdailypaymentreport',
  getSalesOutletWiseReportUrl: 'report/getoutletsalesreport',

  getSalesOrderModeReportUrl: 'report/getsalesordermodereport',
  getSalesDiscountReportUrl: 'report/getsalesdiscountreport',
  getSalesPaymentModeReportUrl: 'report/getsalespaymentmodereport',
  getSalesTableSectionReportUrl: 'report/getsalestablesectionreport',
  getSalesTableReportUrl: 'report/getsalestablereport',
  getSalesCustomerReportUrl: 'report/getsalescustomerreport',
  getSalesCustomerStatementReportUrl: 'report/getsalescustomerstatementreport',
  getSalesBillCancelSummaryReportUrl: 'report/getsalesbillcancelsummaryreport',
  getSalesLocalityReportUrl: 'report/getsaleslocalityreport',
  getSalesBillPaymentReportUrl: 'report/getsalesbillpaymentreport',
  getSalesComplimentoryReportUrl: 'report/getsalescomplimentoryreport',
  getSalesFastMovingReportUrl: 'report/getsalesfastmovingproductreport',
  getSalesVariationReportUrl: 'report/getsalesvariationreport',
  getSalesCashierReportUrl: 'report/getsalescashierreport',
  getSalesWaiterReportUrl: 'report/getsaleswaiterreport',
  getTaxReportUrl: 'report/gettaxsummaryreport',
  getSalesActivityLogReportUrl: 'report/getsalesactivitylogreport',
  getAccountReportUrl: 'report/getaccountreport',
  getBalanceSheetReportUrl: 'report/getbalancesheetreport',
  getTrailBalanceReportUrl: 'report/gettrailbalancereport',
  getProfitLossReportUrl: 'report/getprofitlossreport',
  getPayableReportUrl: 'report/getpayablereport',
  getReceivableReportUrl: 'report/getreceivablereport',


  getOutletShiftCloseReportUrl: 'report/getoutletshiftclosereport',
  getOutletNewCustomerReportUrl: 'report/getoutletnewcustomerreport',
  getOutletCustomerFootFallReportUrl: 'report/getoutletcustomerfootfallreport',


  getSalesDetailsByQuickViewUrl: 'report/getsalesdetailsbyquickview',

  //ProductQuickMenu
  insertProductQuickMenuUrl: 'productquickmenu/insertproductquickmenu',
  checkProductQuickMenuUrl: 'productquickmenu/checkproductquickmenu',
  getProductQuickMenuUrl: 'productquickmenu/getproductquickmenu',
  deleteProductQuickMenuUrl: 'productquickmenu/deleteproductquickmenu',

  //ShiftCloseEmail
  insertShiftCloseEmailUrl: 'shiftcloseemail/insertshiftcloseemail',
  checkShiftCloseEmailUrl: 'shiftcloseemail/checkshiftcloseemail',
  getShiftCloseEmailUrl: 'shiftcloseemail/getshiftcloseemail',
  deleteShiftCloseEmailUrl: 'shiftcloseemail/deleteshiftcloseemail',


  //Employee
  insertEmployeeUrl: 'employee/insertemployee',
  setEmployeeUrl: 'employee/setemployee',
  checkEmployeeUrl: 'employee/checkemployee',
  getEmployeeUrl: 'employee/getemployee',
  deleteEmployeeUrl: 'employee/deleteemployee',

  //Purchase
  insertPurchaseUrl: 'purchase/insertpurchase',
  setPurchaseUrl: 'purchase/setpurchase',
  getPurchaseByListviewUrl: 'purchase/getpurchasebylistview',
  getPurchaseByPurchaseidUrl: 'purchase/getpurchasebypurchaseid',
  deletePurchaseUrl: 'purchase/deletepurchase',

  //Adjtype
  insertAdjtypeUrl: 'adjtype/insertadjtype',
  setAdjtypeUrl: 'adjtype/setadjtype',
  checkAdjtypeUrl: 'adjtype/checkadjtype',
  getAdjtypeUrl: 'adjtype/getadjtype',
  deleteAdjtypeUrl: 'adjtype/deleteadjtype',

  //adj
  insertAdjUrl: 'adj/insertadj',
  setAdjUrl: 'adj/setadj',
  getAdjByListviewUrl: 'adj/getadjbylistview',
  getAdjByAdjidUrl: 'adj/getadjbyadjid',
  deleteAdjUrl: 'adj/deleteadj',

  //Physicalstock
  insertPhysicalstockUrl: 'physicalstock/insertphysicalstock',
  setPhysicalstockUrl: 'physicalstock/setphysicalstock',
  getPhysicalstockByListviewUrl: 'physicalstock/getphysicalstockbylistview',
  getPhysicalstockByPhysicalstockidUrl: 'physicalstock/getphysicalstockbyphysicalstockid',
  deletePhysicalstockUrl: 'physicalstock/deletephysicalstock',
  getRawmaterialPhysicalstockUrl: 'physicalstock/getrawmaterialphysicalstock',

  //xfer
  insertXferUrl: 'xfer/insertxfer',
  setXferUrl: 'xfer/setxfer',
  getXferByListviewUrl: 'xfer/getxferbylistview',
  getXferByXferidUrl: 'xfer/getxferbyxferid',
  deleteXferUrl: 'xfer/deletexfer',
  getCompanyXferUrl: 'xfer/getcompanyxfer',
  
  //Recipe
  insertRecipeUrl: 'recipe/insertrecipe',
  setRecipeUrl: 'recipe/setrecipe',
  getRecipeByListviewUrl: 'recipe/getrecipebylistview',
  getRecipeByProductidUrl: 'recipe/getrecipebyproductid',
  deleteRecipeUrl: 'recipe/deleterecipe',


  //Incometype
  insertIncometypeUrl: 'incometype/insertincometype',
  setIncometypeUrl: 'incometype/setincometype',
  checkIncometypeUrl: 'incometype/checkincometype',
  getIncometypeUrl: 'incometype/getincometype',
  deleteIncometypeUrl: 'incometype/deleteincometype',

  //Expensetype
  insertExpensetypeUrl: 'expensetype/insertexpensetype',
  setExpensetypeUrl: 'expensetype/setexpensetype',
  checkExpensetypeUrl: 'expensetype/checkexpensetype',
  getExpensetypeUrl: 'expensetype/getexpensetype',
  deleteExpensetypeUrl: 'expensetype/deleteexpensetype',

  //Pricetype
  insertPricetypeUrl: 'pricetype/insertpricetype',
  setPricetypeUrl: 'pricetype/setpricetype',
  checkPricetypeUrl: 'pricetype/checkpricetype',
  getPricetypeUrl: 'pricetype/getpricetype',
  deletePricetypeUrl: 'pricetype/deletepricetype',


  //Kitchennotes
  insertKitchennotesUrl: 'kitchennotes/insertkitchennotes',
  setKitchennotesUrl: 'kitchennotes/setkitchennotes',
  checkKitchennotesUrl: 'kitchennotes/checkkitchennotes',
  getKitchennotesUrl: 'kitchennotes/getkitchennotes',
  deleteKitchennotesUrl: 'kitchennotes/deletekitchennotes',

  //Itemcategory
  insertItemcategoryUrl: 'itemcategory/insertitemcategory',
  setItemcategoryUrl: 'itemcategory/setitemcategory',
  checkItemcategoryUrl: 'itemcategory/checkitemcategory',
  getItemcategoryUrl: 'itemcategory/getitemcategory',
  deleteItemcategoryUrl: 'itemcategory/deleteitemcategory',


  //Rawmaterial
  insertRawmaterialUrl: 'rawmaterial/insertrawmaterial',
  setRawmaterialUrl: 'rawmaterial/setrawmaterial',
  checkRawmaterialUrl: 'rawmaterial/checkrawmaterial',
  getRawmaterialUrl: 'rawmaterial/getrawmaterial',
  deleteRawmaterialUrl: 'rawmaterial/deleterawmaterial',


  //PurchaseReturn
  insertPurchaseReturnUrl: 'purchasereturn/insertpurchasereturn',
  setPurchaseReturnUrl: 'purchasereturn/setpurchasereturn',
  getPurchaseReturnByListviewUrl: 'purchasereturn/getpurchasereturnbylistview',
  getPurchaseReturnByPurchaseReturnidUrl: 'purchasereturn/getpurchasereturnbypurchasereturnid',
  deletePurchaseReturnUrl: 'purchasereturn/deletepurchasereturn',




  //Support
  getSupportListviewUrl: 'common/getsupportlistview',
  setSupportUrl: 'common/setsupportstatus',



  //Devices
  setDevicesUrl: 'devices/setdevices',
  getDevicesUrl: 'devices/getdevices',


  getDashboardAdminUrl: 'dashboard/getdashboardadmin',
  getDashboardOrganizationAdminUrl: 'dashboard/getdashboardorganizationadmin',


  //Accounttype
  getAccounttypeUrl: 'accounttype/getaccounttype',
  insertAccounttypeUrl: 'accounttype/insertaccounttype',
  setAccounttypeUrl: 'accounttype/setaccounttype',
  checkAccounttypeUrl: 'accounttype/checkaccounttype',
  deleteAccounttypeUrl: 'accounttype/deleteaccounttype',
  getAccountgroupUrl: 'accounttype/getaccountsgroup',

  //Account
  insertAccountUrl: 'account/insertaccount',
  setAccountUrl: 'account/setaccount',
  checkAccountUrl: 'account/checkaccount',
  getAccountUrl: 'account/getaccount',
  getAccountByPaymenttypeUrl: 'account/getaccountbypaymenttype',
  deleteAccountUrl: 'account/deleteaccount',

  //SubledgerType
  insertSubledgerTypeUrl: 'subledgertype/insertsubledgertype',
  setSubledgerTypeUrl: 'subledgertype/setsubledgertype',
  checkSubledgerTypeUrl: 'subledgertype/checksubledgertype',
  getSubledgerTypeUrl: 'subledgertype/getsubledgertype',
  getSubledgerTypeListviewUrl: 'subledgertype/getsubledgertypebylistview',
  deleteSubledgerTypeUrl: 'subledgertype/deletesubledgertype',


  //Subledger
  insertSubledgerUrl: 'subledger/insertsubledger',
  setSubledgerUrl: 'subledger/setsubledger',
  checkSubledgerUrl: 'subledger/checksubledger',
  getSubledgerUrl: 'subledger/getsubledger',
  deleteSubledgerUrl: 'subledger/deletesubledger',


  //CostCenter
  insertCostCenterUrl: 'costcenter/insertcostcenter',
  setCostCenterUrl: 'costcenter/setcostcenter',
  checkCostCenterUrl: 'costcenter/checkcostcenter',
  getCostCenterUrl: 'costcenter/getcostcenter',
  deleteCostCenterUrl: 'costcenter/deletecostcenter',

  //Jv
  insertJvUrl: 'jv/insertjv',
  setJvUrl: 'jv/setjv',
  getJvByListviewUrl: 'jv/getjvbylistview',
  getJvByJvidUrl: 'jv/getjvbyjvid',
  deleteJvUrl: 'jv/deletejv',

  //Defaultledger
  getDefaultAccountUrl: 'defaultledger/getdefaultaccount',
  setDefaultAccountUrl: 'defaultledger/setdefaultaccount',
  getDefaultAdjustmentUrl: 'defaultledger/getdefaultaccountadjustment',


  insertPostingUrl: 'posting/insertposting',
  insertUnPostingUrl: 'posting/insertunposting',
  //Payment
  insertPaymentUrl: 'payment/insertpayment',
  setPaymentUrl: 'payment/setpayment',
  getPaymentByListviewUrl: 'payment/getpaymentbylistview',
  getPaymentUrl: 'payment/getpayment',
  deletePaymentUrl: 'payment/deletepayment',
  getPaymentPayableUrl: 'payment/getpaymentpayable',

  //Lpo
  insertLpoUrl: 'lpo/insertlpo',
  setLpoUrl: 'lpo/setlpo',
  getLpoByListviewUrl: 'lpo/getlpobylistview',
  getLpoByLpoidUrl: 'lpo/getlpobylpoid',
  deleteLpoUrl: 'lpo/deletelpo',

  //Transfer
  insertTransferUrl: 'transfer/inserttransfer',
  setTransferUrl: 'adj/setadj',
  getTransferByListviewUrl: 'adj/gettransferbylistview',
  getTransferByTransferidUrl: 'adj/gettransferbytransferid',
  deleteTransferUrl: 'adj/deletetransfer',

}









